import { ImageKitImageProps } from 'components/common/ImageKitImage';

const getVideoThumbnailUrl = (url: string) => {
  if (url.includes('content/raw/videos')) {
    const parts = url.split('/');

    if (!parts || !Array.isArray(parts) || !parts.length) return url;

    const fileName = parts[parts.length - 1];

    if (!fileName) return url;

    const newFileName = fileName.split('.')[0] + '_thumbnail.jpeg';

    return url.replace(fileName, newFileName);
  }

  return url;
};

const IK_BASE_URL_ENDPOINT = 'https://ik.imagekit.io/vzzk789fgbt/';
export const getImageKiteEndPointAndPath = ({
  path,
  videoPreview,
}: Pick<ImageKitImageProps, 'path' | 'videoPreview'>) => {
  let urlEndpoint = IK_BASE_URL_ENDPOINT;
  let cleanedPath = path;
  const isAws = path.indexOf('amazonaws.com');
  if (isAws >= 0) {
    // Handle path if image is on new AWS Bucket
    cleanedPath = path.substring(isAws + 14);
    if (path.includes('staging')) {
      urlEndpoint += 'staging/';
    }
  } else {
    // Handle path if image is on legacy GCP Storage
    const gcpPathIndex = path.indexOf('appspot.com');
    const queryString = path.indexOf('?');
    cleanedPath = path.substring(
      gcpPathIndex + 12,
      queryString > 0 ? queryString : path.length
    );
    if (path.includes('development')) {
      urlEndpoint += 'legacy-staging/';
    } else {
      urlEndpoint += 'legacy/';
    }
  }

  if (videoPreview) {
    cleanedPath = getVideoThumbnailUrl(path);
  }

  cleanedPath = decodeURIComponent(cleanedPath);
  return { urlEndpoint, imageKitPath: cleanedPath };
};
